const productDetails_CN_Locale = {
    'productDetails.CUPID': 'CUPID(丘比特)',
    'productDetails.productIntroduce': '产品介绍',
    'productDetails.title1': '高效提升标注工作效率',
    'productDetails.name1': '一站式医学影像智能标注软件',
    'productDetails.product_introduced1': 'Pair作为首款国产一站式医学影像智能标注软件，具备专业便捷、通用易用且高度智能化的特点。仅需用户提供少量标记即可实现解剖结构的精细标注，高效节省用户80%的手动标注时间，是医生科研工作的得力助手。',
    'productDetails.demo1_title1': '全部模态及格式',
    'productDetails.demo1_content1': '支持多种医学影像、自然图像支持二维图像、视频及三维数据',
    'productDetails.demo1_title2': '多种标注种类',
    'productDetails.demo1_content2': '涵盖人工智能所需的20余种标注任务，满足用户多样需求',
    'productDetails.demo1_title3': '大规模标注',
    'productDetails.demo1_content3': '具备优异的工作流，可支持数千张图像或长视频文件的同时导入',
    'productDetails.demo1_title4': '流程规范',
    'productDetails.demo1_content4': '用户可通过自定义配置文件，自定义标签层次结构，规范简化标注流程',

    'productDetails.title2': '形影不离 智AI新生',
    'productDetails.name2': '产前智能超声筛查系统',
    'productDetails.product_introduced2': 'CUPID 产前智能超声筛查系统，基于超声影像分析和人工智能技术，为医生在产前超声筛查中提供智能引导、实时分析、自动采集规范图、自动测量等功能，从而实现智能分析、自动报告、高效质控;替代高耗时、低价值的操作，解决实际超声产前筛查工作面临的高经验依赖、高误漏诊风险、高质控成本、低质控成效等一系列临床痛点。',
    'productDetails.demo2_title1': '精确率',
    'productDetails.demo2_content1': '精确识别>95%',
    'productDetails.demo2_title2': '全孕周覆盖',
    'productDetails.demo2_content2': '全方位涵盖早、中、晚孕产前超声检查',
    'productDetails.demo2_title3': '实时监测',
    'productDetails.demo2_content3': '动态检测70+个标准切面近300+项胎儿解剖结构',

    'productDetails.title3': '智敬女性',
    'productDetails.name3': '盆底智能超声筛查系统',
    'productDetails.product_introduced3': 'AutoPelvic 盆底智能超声筛查系统，适用于成年女性盆底超声检查。产品集自动识别、精准测量、快速分析为一体，高效实现盆底全流程临床检查的辅助诊断；极大程度解决传统盆底超声检查耗时长、难度大、检查项目繁杂等临床痛点，提高盆底超声检查的规范化和标准化，提升临床诊查效率。',
    'productDetails.function1_Title': '全功能',
    'productDetails.function1_Content1': '适用：2D静态超声影像、2D动态超声影像、3D盆底超声影像',
    'productDetails.function1_Content2': '涵盖：前盆腔、中盆腔、后盆腔、肛提肌、肛门括约肌',
    'productDetails.function1_Content3': '解剖结构：耻骨、膀胱、阴道、子宫、尿道、直肠、肛提肌裂孔',
    'productDetails.demo3_content1': '全流程评估盆底功能',
    'productDetails.demo3_content2': '支持经阴道盆底检查',
    'productDetails.demo3_content3': '支持经腹部盆底检查',
    'productDetails.demo3_content4': '100%覆盖所有超声机',
    'productDetails.demo3_content5': '缩短50%检查时长',
    'productDetails.demo3_content6': '符合多版专家临床共识',

    'productDetails.title4': '医技帮手 请多智教',
    'productDetails.name4': '婴幼儿髋关节智能超声影像处理系统',
    'productDetails.product_introduced4': 'AutoDDH 婴幼儿髋关节智能超声影像处理系统，用于婴幼儿髋关节发育不良超声筛查，是一款集动态识别标准切面、精准测量发育参数、自动标识解剖结构为一体的智能辅助筛查软件；可大幅降低对于医生专业水平的依赖，提高诊断效率和精度，实现自动质量控制和示教。',
    'productDetails.demo4_title1': '实时质控',
    'productDetails.demo4_content1': '自动捕获标准切面参数精准自动测量',
    'productDetails.demo4_title2': '功能完善',
    'productDetails.demo4_content2': '支持多种权威方法全面量化发育评估',
    'productDetails.demo4_title3': '适用性广',
    'productDetails.demo4_content3': '部署便捷即连即用兼容所有超声品牌',
    'productDetails.demo4_title4': '示教一体',
    'productDetails.demo4_content4': '专家知识融于系统助力新手快速成长',

    'productDetails.title5': '火眼金睛，无“结”可藏',
    'productDetails.name5': '乳腺超声辅助筛查系统',
    'productDetails.product_introduced5': 'AutoBreast 乳腺超声辅助筛查系统，适用于女性乳腺结节检查，是一款集动态识别病灶、实时分析病灶良恶性、自动存取最优切面及一键生成智能结构化报告为一体的辅助检查软件；为各级医院医生诊断乳腺疾病提供智能筛查服务，全面提升诊断结果标准化，有效减少检查漏误诊率和降低乳腺筛查人力成本。',
    'productDetails.function2_Title': '标准化BI-RADS分级',
    'productDetails.function2_Content1': '“检”：实时识别',
    'productDetails.function2_Content2': '“诊”：自动测量',
    'productDetails.function2_Content3': '“报”：一键报告',

    'productDetails.title6': '为您的健康 保驾护航',
    'productDetails.name6': '甲状腺超声辅助筛查评估系统',
    'productDetails.product_introduced6': 'AutoThyroid 甲状腺超声辅助筛查评估系统，适用于甲状腺病灶超声筛查，基于人工智能技术，提供动态定位病灶、智能评估病灶特征、标准化测量病灶参数等核心功能，可有效降低对操作者临床经验的依赖程度，减少误诊漏诊概率，提升诊断结果，降低甲状腺筛查时间成本，普惠基层筛查。',
    'productDetails.function3_Title': '功能特点',
    'productDetails.function3_Content1': '标准化TI-RADS分级',
    'productDetails.function3_Content2': '动态检测',
    'productDetails.function3_Content3': '精细分析',

    'productDetails.title7': '智能“心动”',
    'productDetails.name7': '心脏超声智能辅助筛查系统',
    'productDetails.product_introduced7': 'AutoCardiac 心脏超声智能辅助筛查系统，适用于成人超声心动图检查。基于自主研发的心脏超声 AI 模型，提供结构实时分析、测量项自动测量、标准切面自动留图等常规应用功能，并提供心肌运动轨迹动态追踪、心肌功能和血流动力学智能分析等高级应用。另外提供智能质控、示教引导，可有效减少误诊漏诊率，提高临床工作效能。',
    'productDetails.function4_Title': '产品特点',
    'productDetails.function4_Content1': '全心智能分析',
    'productDetails.function4_Content2': '智能质控',
    'productDetails.function4_Content3': '超精度识别测量',

    'productDetails.title8': '智孕新生',
    'productDetails.name8': '辅助生殖自动测量系统',
    'productDetails.product_introduced8': 'AutoFollicle 辅助生殖自动测量系统，基于超声影像分析和人工智能技术，自主开发实现卵巢卵泡识别、子宫内膜容受性分析，并贴合临床辅助生殖下超声卵泡监测场景实现智能排序统计、参数自动测量且自动生成结构化报告等功能。解决场景下手动的测量、排序、计数等工作繁琐、易出错的问题，提供全智能一键“分析”的智能辅助生殖超声筛查系统。',
    'productDetails.function5_Title': '功能特点',
    'productDetails.function5_Content1': '卵泡自动测量',
    'productDetails.function5_Content2': '子宫内膜容受性分析',

    'productDetails.title9': '为超声质控 数智化升级赋能',
    'productDetails.name9': '智能超声质控平台',
    'productDetails.product_introduced9': 'ATLAS 智能超声质控平台，基于人工智能技术，实现对超声影像的批量智能识别与量化评估；以统一、客观标准辅助超声质控工作。提供数据批量质控、智能质控一键生成、多维度数据分析、质控指标动态可视化核心功能的同时，辅以轻量化的数据管理、简便的部署方式，全面助力质控管理工作开展，确保其高质量、低耗时、常态化运行。',
    'productDetails.function6_Title': '功能特点',
    'productDetails.function6_Content1': '毫秒级别反馈',
    'productDetails.function6_Content2': '标准量化评分',
    'productDetails.function6_Content3': '一键质控报告',

}
export default productDetails_CN_Locale
